import React from "react";
import Navbar from "./Navbar";
import { Outlet } from "react-router-dom";

export default function Layout() {
  return (
    <div className="flex">
      <Navbar />
      <div className="flex-1 min-h-screen bg-[#0F1C17]">
        <Outlet />
      </div>
    </div>
  );
}
